import * as React from 'react';
import { NumericField } from './NumericField';
import TextField from 'react-md/lib/TextFields';
//import TextField from '@material-ui/core/TextField';
// import { Cell, Grid } from 'react-md/lib/Grids';
import Grid from '@material-ui/core/Grid';
import './AgeInput.scss';
import './style.css';

interface Props {
    ageInMonths?: number;
    onChange: (ageInMonths: number) => void;
}

let months: number | undefined;
let years: number | undefined;

export class AgeInput extends React.Component<Props> {

    public render() {
        if (this.props.ageInMonths !== undefined && !isNaN(this.props.ageInMonths)) {
            months = this.props.ageInMonths % 12;
            years = (this.props.ageInMonths - months) / 12;
            if (years == 0)
                years = undefined
            if (months == 0)
                months = undefined
        }

        return (
            <Grid container className="age-input">
                <Grid item xs={4} className="age-input-field">

                    <div className="input-name">
                        <input type="number" className="call numeric-field" id="ageYearsInput" onChange={(evt) => this.onYearsUpdated(evt)} value={years} placeholder="years" />
                        <span className="underline-animation"></span>
                    </div>
                </Grid>
                <Grid item xs={4} className="age-input-field">

                    <div className="input-name">
                        <input type="number" id="ageMonthsInput" className="numeric-field call"
                            onChange={(evt) => this.onMonthsUpdated(evt)}
                            onClick={(evt) => evt.preventDefault()}
                            value={months}
                            placeholder="months" />
                        <span className="underline-animation"></span>
                    </div>
                </Grid>
            </Grid>
        );
    }

    private onYearsUpdated = (event: any) => {
        var year = event.target.value;
        if (parseInt(year) < 0) {
            event.target.value = undefined
            year = ''
        }
        const monthsUpdated = (this.props.ageInMonths || 0) % 12;
        if (year != '') {
            year = parseInt(year);
            let ageInMonthsTotal = year * 12 + monthsUpdated;
            this.props.onChange(ageInMonthsTotal);
        } else {
            this.props.onChange(monthsUpdated);
        }
    }

    private onMonthsUpdated = (event: any) => {
        var month = event.target.value;
        if (parseInt(month) < 0)
            event.target.value = undefined
        month = month == '' ? '' : month;
        if (month != '') {
            month = parseInt(month);
        }
        const oldMonths = (this.props.ageInMonths || 0) % 12;

        if (month >= 0 && month <= 11 && month != '') {
            let ageInMonthsUpdated: number;
            ageInMonthsUpdated = (this.props.ageInMonths || 0) - oldMonths;
            ageInMonthsUpdated += month;
            this.props.onChange(ageInMonthsUpdated);
        } else if (month == '') {
            let ageInMonthsOnly: number;
            ageInMonthsOnly = (this.props.ageInMonths || 0) - oldMonths;
            this.props.onChange(ageInMonthsOnly);
        }
    }

    // private onYearsUpdated = (years: any) => {
    //     console.log(years,'sdf');
    //     const months = (this.props.ageInMonths || 0) % 12;
    //     const ageInMonths = years * 12 + months;
    //     this.props.onChange(ageInMonths);
    // };

    // private onMonthsUpdated = (months: any) => {
    //     months = months=='' ? 0 : months;
    //     months = parseInt(months);
    //     const oldMonths = (this.props.ageInMonths || 0) % 12;
    //     let ageInMonths: number;
    //     if (months >= 0 && months <= 11) {
    //         ageInMonths = (this.props.ageInMonths || 0) - oldMonths  ;
    //         ageInMonths += months;
    //         this.props.onChange(ageInMonths);
    //     }
    // }    
}